import React from "react";
import { Link } from "react-router-dom";
import { staff, volunteers } from "../data/team";
import "./Staff.css";

const PhoneIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.03 2.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
  </svg>
);
const MailIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);
const MapPinIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

function TeamCard({ member }) {
  return (
    <article className="team-card" aria-labelledby={`member-${member.id}`}>
      <div className="team-card-img-wrap">
        <img src={member.image} alt={member.name} loading="lazy" />
      </div>
      <div className="team-card-body">
        <h3 id={`member-${member.id}`}>{member.name}</h3>
        <p className="team-card-title">{member.title}</p>
        {member.location && (
          <p className="team-card-location">
            <MapPinIcon /> {member.location}
          </p>
        )}
        <p className="team-card-bio">{member.bio}</p>
        {member.contact && (
          <div className="team-card-contact">
            {member.phone && (
              <a
                href={`tel:${member.phone.replace(/\s/g, "")}`}
                className="team-contact-link"
              >
                <PhoneIcon /> {member.phone}
              </a>
            )}
            {member.email && (
              <a href={`mailto:${member.email}`} className="team-contact-link">
                <MailIcon /> {member.email}
              </a>
            )}
          </div>
        )}
      </div>
    </article>
  );
}

export default function Staff() {
  return (
    <main>
      <section className="page-hero" aria-label="Staff page hero">
        <div
          className="page-hero-bg"
          style={{ backgroundImage: "url('/images/gallery/children-04.jpg')" }}
        />
        <div className="container page-hero-content">
          <span className="eyebrow" style={{ color: "var(--amber-light)" }}>
            The People Behind the Mission
          </span>
          <h1>Staff &amp; Volunteers</h1>
          <p>
            Meet the core team and volunteer groups who make every programme
            possible.
          </p>
        </div>
      </section>

      {/* STAFF */}
      <section className="section" aria-labelledby="staff-heading">
        <div className="container">
          <div className="section-title">
            <span className="eyebrow">Leadership Team</span>
            <h2 id="staff-heading">Our Core Staff</h2>
            <div className="divider divider-center" />
            <p>
              The staff directly responsible for the Foundation's operations,
              programmes, and strategy.
            </p>
          </div>
          <div className="team-grid">
            {staff.map((member) => (
              <TeamCard key={member.id} member={member} />
            ))}
          </div>
        </div>
      </section>

      {/* VOLUNTEERS */}
      <section
        className="section volunteers-section"
        aria-labelledby="volunteers-heading"
      >
        <div className="container">
          <div className="section-title">
            <span className="eyebrow">Community Power</span>
            <h2 id="volunteers-heading">Our Volunteer Teams</h2>
            <div className="divider divider-center" />
            <p>
              Our volunteer teams are the backbone of daily operations — showing
              up every week to feed, care, and support.
            </p>
          </div>
          <div className="volunteers-grid">
            {volunteers.map((v) => (
              <article className="volunteer-card" key={v.id}>
                <img src={v.image} alt={v.title} loading="lazy" />
                <div className="volunteer-card-body">
                  <h3>{v.name}</h3>
                  <p className="volunteer-card-title">{v.title}</p>
                  <p>{v.bio}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* JOIN CTA */}
      <section className="cta-band" aria-label="Volunteer CTA">
        <div className="container cta-band-inner">
          <div>
            <h2>Join Our Team</h2>
            <p>
              We welcome volunteers with skills in care, education,
              administration, communications, and more.
            </p>
          </div>
          <div className="cta-band-actions">
            <Link to="/get-involved" className="btn btn-primary btn-lg">
              Volunteer Now
            </Link>
            <Link to="/donate" className="btn btn-secondary">
              Donate Instead
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
